import React, { useEffect, useRef, useState } from "react";

import { FcEngineering } from "react-icons/fc";
import LoadingPage from "../../Components/layouts/loading";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { Toast } from "../../CustomComponent/toast";
import performRequest from "../../api/request";
import { roundOffCost } from "../../Components/Functions/amt.fun";
import { FaFilePdf } from "react-icons/fa6";
import Footer from "../../Components/Footer/footer";
import PolyhouseDesigner from "../../Pages/construction sketch/polyhouse_construction";
import { LazyImageComponent } from "../../CustomComponent/lazy_loading_image";

const OrderCeaKitTable = ({
  hydrponicType,
  length,
  width,
  hydrponicPercentage,
  fingerPrint,
  sFingerPrint,
}) => {
  const printRef = useRef();
  const paymentRef = useRef();
  const [ceaMaterialList, setCEAMaterialList] = useState([]);
  const [ceaNVPH, setCEAList] = useState(ceaMaterialList);
  const [handlingCharges, setHandlingCharges] = useState(0);
  const [footingDiaM, setFootingDiaM] = useState(0.35); // visual marker only
  const [blockName, setBlockName] = useState([]);
  const [gst18Percent, setGst18Percent] = useState(0);
  const [gst12Percent, setGst12Percent] = useState(0);
  const [gst5Percent, setGst5Percent] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [fabricationCharges, setFabricationCharges] = useState(0);

  const [showAll, setShowAll] = useState(false);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");

  const [loading, setLoading] = useState(false);

  const [storeFingerPrint, setStoreFingerPrint] = useState(sFingerPrint);
  const [hoveredImage, setHoveredImage] = useState(null);

  useState(() => {
    if (storeFingerPrint) {
      setShowAll(storeFingerPrint);
    }
  }, [storeFingerPrint]);

  const handleUserData = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[6-9]\d{9}$/; // Indian 10-digit numbers starting 6–9

    if (!emailRegex.test(email)) {
      Toast("error", "Invalid Email");
      return;
    }

    if (!mobileRegex.test(mobile)) {
      console.error("Invalid Mobile Number!");
      Toast("error", "Invalid Mobile");
      return;
    }

    let data = { fingerPrint, email, mobile, name };
    setLoading(true);
    performRequest("POST", "/cea-order-kit/create-user-data", data)
      .then((res) => {
        setStoreFingerPrint(res?.data?.fingerPrint);
        if (res?.data?.fingerPrint) {
          setShowAll(true);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  // getting CEA List
  useEffect(() => {
    if (hydrponicType === "cea-nvph") {
      performRequest("GET", `/materialPlanning/getAllCEAList`)
        .then((res) => {
          if (res.status === 200) {
            setCEAMaterialList(res?.data.CEAList);
          } else {
            Toast("error", "Error while getting Details!");
          }
          setLoading(false);
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    }
  }, []);

  let indexCount = 0;
  let Sqmtr = +length * +width;
  let SqFt = Math.ceil(Sqmtr * 10.764);
  let UsableSqMtr = (+length - 4) * (+width - 4); // this four maybe from the hockey length and width which is 4
  let HockeyLength = 4;
  let HockeyWidth = 4;
  let AvailableLength = +length - HockeyLength;
  let AvailableWidth = +width - HockeyWidth;
  let LengthBreakdown = AvailableLength / 4;
  let WidthBreakdown = AvailableWidth / 8;
  let TotalBlocks8X4Mtr = LengthBreakdown * WidthBreakdown;
  let Lenghtinft = (AvailableLength * 3.281).toFixed(3); // 1 meter=3.28084 feet round of 3.281
  let Widthinft = (AvailableWidth * 3.281).toFixed(3);
  let UsableWidth = Math.ceil(Widthinft - 5);
  let availWidth = width - 4;
  let growbagLines = (availWidth / 8) * 6;
  // Finding totalflatbed
  let TotalFlatbed;

  if (+hydrponicPercentage == 25) {
    TotalFlatbed = (TotalBlocks8X4Mtr / 4) * 2;
  } else if (+hydrponicPercentage == 50) {
    TotalFlatbed = (TotalBlocks8X4Mtr / 2) * 2;
  } else if (+hydrponicPercentage == 75) {
    TotalFlatbed = ((TotalBlocks8X4Mtr * 3) / 2) * 2;
  } else if (+hydrponicPercentage == 100) {
    TotalFlatbed = TotalBlocks8X4Mtr * 2;
  }

  let AFrameBlock20ft = Math.floor(UsableWidth / 20);
  let calculatedValue = (UsableWidth / 20 - AFrameBlock20ft) * 20;
  let ExtraAFrameBlockinft = calculatedValue <= 8 ? 0 : calculatedValue;
  let TotalAFrameBlocks = AFrameBlock20ft * 3 * LengthBreakdown;
  let AFrameperline = AFrameBlock20ft * 6;
  let calculatedValueAFrameExtra = Math.ceil(
    (ExtraAFrameBlockinft - 2) / 3.5 + 1
  );
  let AFrameExtra =
    calculatedValueAFrameExtra <= 1 ? 0 : calculatedValueAFrameExtra;

  let Aframelines = Math.floor(Lenghtinft / 7);
  let TotalAframes = AFrameperline * 6 + AFrameExtra * 3 * LengthBreakdown;
  let NFTpipesinFt =
    (AFrameBlock20ft * 20 + ExtraAFrameBlockinft) * Aframelines;
  let Layer7Pipesft = NFTpipesinFt * 14;
  let TotalNumberofPipes = Layer7Pipesft / 20;
  let Foggers = TotalBlocks8X4Mtr * 2;
  let FoggerLatteralPipe = Foggers * 4 + 12;
  let TotalNewFlatbedInstallation = TotalBlocks8X4Mtr * 2;

  /// CEA - NVPH
  let OD76Pipe = Math.ceil(
    (6500 * WidthBreakdown * 2 +
      4500 * ((WidthBreakdown + 1) * (LengthBreakdown + 1))) /
      6000
  );
  let OD60Pipe = Math.ceil(
    (1000 *
      ((LengthBreakdown + 1) * (WidthBreakdown + 1) + WidthBreakdown * 2) +
      8000 * ((LengthBreakdown - 1) * WidthBreakdown) +
      4000 * WidthBreakdown * 4 +
      2000 * ((LengthBreakdown - 1) * WidthBreakdown)) /
      6000
  );
  let OD48Pipe = Math.ceil(
    (5500 * ((LengthBreakdown + 1 + (WidthBreakdown * 2 + 1)) * 2)) / 6000
  );
  let OD42Pipe = Math.ceil(
    (4000 * (LengthBreakdown * WidthBreakdown) +
      4000 * (LengthBreakdown * 2) +
      4000 * ((LengthBreakdown - 1) * 2 * (WidthBreakdown - 1)) +
      6000 * (WidthBreakdown * 2 - 2) +
      5500 * ((LengthBreakdown + 1) * WidthBreakdown) +
      4300 * ((LengthBreakdown + 1) * WidthBreakdown) +
      1200 * ((LengthBreakdown + 1 + (WidthBreakdown * 2 + 1)) * 2) +
      4000 * (LengthBreakdown * 2 + WidthBreakdown * 4)) /
      6000
  );
  let OD33Pipe = Math.ceil(
    (4000 * (WidthBreakdown * 2 + LengthBreakdown * 2) +
      5000 * (WidthBreakdown * 4) +
      1500 * ((LengthBreakdown + 1) * 2 * WidthBreakdown) +
      1840 * ((LengthBreakdown + 1) * 2 * WidthBreakdown)) /
      6000
  );

  let OD27Pipe = Math.ceil(
    (1000 * ((LengthBreakdown + 1) * WidthBreakdown) +
      6000 * (((AvailableWidth + 1) * 2 + (AvailableLength + 1) * 2) / 6)) /
      6000
  );

  useEffect(() => {
    if (
      length &&
      width &&
      hydrponicType &&
      hydrponicType === "cea-nvph" &&
      hydrponicPercentage
    ) {
      // Build query params safely
      const params = new URLSearchParams({
        length: length.toString(),
        width: width.toString(),
        hydroponicType: hydrponicType,
        hydrponicPercentage: hydrponicPercentage.toString(),
      });

      performRequest("GET", `/materialPlanning/calculateceaList?${params}`)
        .then((res) => {
          if (res.status === 200) {
            setCEAList(res.data.ceaMaterialList);
          } else {
            Toast("error", "Error while getting Details!");
          }
          setLoading(false);
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    }
  }, [length, width, hydrponicType, hydrponicPercentage]);

  const handleDownload = () => {
    if (!printRef.current) return;

    const printContent = printRef.current.innerHTML;
    const printPaymentRef = paymentRef?.current?.innerHTML || "";
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);

    // ✅ Mobile: use window.open (iframe print gets ignored)
    if (isMobile) {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>Material List</title>
            <style>
              body { font-family: Arial, sans-serif; font-size:12px; margin: 20px; text-align: left; }
              table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
              th, td { border: 1px solid black; padding: 4px; text-align: left; width:auto }
              th { background-color: white; }
              td { width:200px; }
              img { max-width: 100%; height: auto; display: block; margin: 2px; }
            </style>
          </head>
          <body>
            ${printContent}
            ${printPaymentRef}
          </body>
        </html>
      `);
      printWindow.document.close();

      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      };
      return;
    }

    // ✅ Desktop: use iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`
      <html>
        <head>
          <title>Material List</title>
          <style>
            body { font-family: Arial, sans-serif; font-size:12px; margin: 20px; text-align: left; }
            table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
            th, td { border: 1px solid black; padding: 4px; text-align: left; width:auto }
            th { background-color: white; }
            td { width:200px; }
            img { max-width: 100%; height: auto; display: block; margin: 2px; }
          </style>
        </head>
        <body>
          ${printContent}
          ${printPaymentRef}
        </body>
      </html>
    `);
    doc.close();

    iframe.onload = () => {
      const images = doc.images;
      let loaded = 0;

      if (images.length === 0) {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
        return;
      }

      // Remove lazy-loading for Cloudinary images
      Array.from(images).forEach((img) => {
        img.removeAttribute("loading");
        img.crossOrigin = "anonymous";
        img.decoding = "sync";
      });

      const fallback = setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
      }, 4000);

      Array.from(images).forEach((img) => {
        if (img.complete) {
          loaded++;
        } else {
          img.onload = img.onerror = () => {
            loaded++;
            if (loaded === images.length) {
              clearTimeout(fallback);
              iframe.contentWindow.focus();
              iframe.contentWindow.print();
              document.body.removeChild(iframe);
            }
          };
        }
      });

      if (loaded === images.length) {
        clearTimeout(fallback);
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
      }
    };
  };

  useEffect(() => {
    if (ceaNVPH?.length > 0) {
      let baseCost = 0;
      let gst18Base = 0;
      let gst12Base = 0;
      let gst5Base = 0;
      let fabricationChargesTotal = 0;
      let handlingChargesTotal = 0;

      // ✅ Single reduce loop
      ceaNVPH.forEach((item) => {
        const itemCost = parseFloat(item.cost) || 0;
        const totalItemCost = itemCost * (item.count || 0);
        baseCost += totalItemCost;

        if (item?.gst === "18") {
          gst18Base += totalItemCost;
        } else if (item?.gst === "12") {
          gst12Base += totalItemCost;
        } else if (item?.gst === "5") {
          gst5Base += totalItemCost;
        }
        if (item?.fabricationChargesMarkup) {
          const itemCost = parseFloat(item.cost) || 0;
          const totalItemCost = itemCost * (item.count || 0);
          let value =
            totalItemCost * parseFloat(item?.fabricationChargesMarkup);
          let fbChargesPercent = value / 100;
          fabricationChargesTotal = fabricationChargesTotal + fbChargesPercent;
        }
        if (item?.handlingCharges) {
          const itemCost = parseFloat(item.cost) || 0;
          const totalItemCost = itemCost * (item.count || 0);
          let value = totalItemCost * parseFloat(item?.handlingCharges);
          let hcChargesPercent = value / 100;
          handlingChargesTotal = handlingChargesTotal + hcChargesPercent;
        }
      });

      // ✅ GST Calculations
      const gst18Percent = parseFloat((gst18Base * 0.18).toFixed(2));
      const gst12Percent = parseFloat((gst12Base * 0.12).toFixed(2));
      const gst5Percent = parseFloat((gst5Base * 0.05).toFixed(2));

      setGst18Percent(gst18Percent);
      setGst12Percent(gst12Percent);
      setGst5Percent(gst5Percent);

      //  Fabrication charges (18% GST)
      const fbprocess18 = parseFloat(
        (fabricationChargesTotal * 0.18).toFixed(2)
      );
      const hcProcess18 = parseFloat((handlingChargesTotal * 0.18).toFixed(2));
      const updateFabricationCharges = parseFloat(
        (fabricationChargesTotal + fbprocess18).toFixed(2)
      );
      const updateHandlingCharges = parseFloat(
        (handlingChargesTotal + hcProcess18).toFixed(2)
      );
      setFabricationCharges(updateFabricationCharges);
      setHandlingCharges(updateHandlingCharges);

      //  Final total
      const totalCost = parseFloat(
        (
          baseCost +
          gst18Percent +
          gst12Percent +
          gst5Percent +
          updateFabricationCharges +
          updateHandlingCharges
        ).toFixed(2)
      );
      setTotalCost(totalCost);
    } else {
      setGst18Percent(0);
      setGst12Percent(0);
      setGst5Percent(0);
      setFabricationCharges(0);
      setTotalCost(0);
    }
  }, [ceaNVPH]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row align-items-center d-flex">
                <div className=" col-md-8">
                  <h2 className="page-title mb-1">
                    <FcEngineering className="fs-2  me-1" />
                    Material Planning {`(${length} * ${width})`}
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xl">
              <div className="row">
                <div className="col-12 m-auto">
                  <div className="row">
                    <div className="col-lg-3 col-md-12 d-flex flex-column gap-3">
                      <div className="card table-responsive">
                        <div className="card-header text-center fs-3 fw-bold">
                          Specifications
                        </div>
                        <table
                          className="table table-vcenter border text-start
                        "
                        >
                          <thead>
                            <tr>
                              <th>Sr</th>
                              <th>Item Name</th>
                              <th>Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{++indexCount}</td> <td>SqMtr</td>
                              <td>{Sqmtr}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>SqFt</td>
                              <td>{SqFt}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>Usable SqMtr</td>
                              <td>{UsableSqMtr}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>Length (div / 4)</td>
                              <td>{length}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>Width (div / 8)</td>
                              <td>{width}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>Hockey</td>
                              <td>{4}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>Avl Length / 4</td>
                              <td>{AvailableLength}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>Avl Width / 8</td>
                              <td>{AvailableWidth}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>Length Breakdown</td>
                              <td>{LengthBreakdown}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td> <td>Width Breakdown</td>
                              <td>{WidthBreakdown}</td>
                            </tr>
                            <tr>
                              <td>{++indexCount}</td>
                              <td>Total Blocks (8X4Mtr)</td>
                              <td>{TotalBlocks8X4Mtr}</td>
                            </tr>
                            {hydrponicType === "growbags" && (
                              <tr>
                                <td>{++indexCount}</td>
                                <td>Growbag Lines</td>
                                <td>{growbagLines}</td>
                              </tr>
                            )}
                            {hydrponicType === "cea-nvph" && (
                              <React.Fragment>
                                <tr>
                                  <td>{++indexCount}</td>
                                  <td>76 OD</td>
                                  <td>{OD76Pipe}</td>
                                </tr>
                                <tr>
                                  <td>{++indexCount}</td>
                                  <td>60 OD</td>
                                  <td>{OD60Pipe}</td>
                                </tr>
                                <tr>
                                  <td>{++indexCount}</td>
                                  <td>48 OD</td>
                                  <td>{OD48Pipe}</td>
                                </tr>
                                <tr>
                                  <td>{++indexCount}</td>
                                  <td>42 OD</td>
                                  <td>{OD42Pipe}</td>
                                </tr>
                                <tr>
                                  <td>{++indexCount}</td>
                                  <td>33 OD</td>
                                  <td>{OD33Pipe}</td>
                                </tr>
                                <tr>
                                  <td>{++indexCount}</td>
                                  <td>27 OD</td>
                                  <td>{OD27Pipe}</td>
                                </tr>
                              </React.Fragment>
                            )}
                          </tbody>
                        </table>
                      </div>

                      <div className="mb-3">
                        <img
                          src="http://www.listercarterhomes.com/wp-content/uploads/2013/11/dummy-image-square.jpg"
                          alt=""
                          style={{ filter: "blur(5px)" }}
                        />

                        <button
                          className="btn btn-primary flex-grow-1 mt-2 "
                          data-bs-toggle="modal"
                          data-bs-target="#modal-report-2"
                          id="opensuccessmodal-2"
                        >
                          View Layout Design
                        </button>
                      </div>
                    </div>

                    {hydrponicType === "cea-nvph" && (
                      <div className="col-lg-9 col-md-12">
                        <div ref={printRef} className="card table-responsive">
                          <div className="card-header text-start fs-2 fw-bold">
                            Material List-CEA-NVPH{" "}
                            {`(${length} length * ${width} width)`}
                            <div className="col-6 text-end">
                              <button
                                className="btn btn-primary"
                                data-bs-toggle="modal"
                                data-bs-target="#modal-report-1"
                                id="opensuccessmodal"
                                style={showAll ? { display: "none" } : {}}
                              >
                                Get Full Access
                              </button>
                            </div>
                          </div>
                          <table className="table table-vcenter text-start border">
                            <thead>
                              <tr>
                                <th>Sr</th>
                                <th>Image</th>
                                <th>Item Name</th>
                                <th>Specifications</th>
                                <th>Quantity</th>
                                <th>Unit Price</th>
                                <th>Price</th>
                                <th>Final Price</th>
                              </tr>
                            </thead>

                            <tbody>
                              {ceaNVPH
                                ?.filter((item) => item?.count)
                                .map((item, index) =>
                                  item?.count !== "" ? (
                                    <tr
                                      key={index}
                                      className={
                                        !showAll && index >= 3
                                          ? "text-muted"
                                          : ""
                                      }
                                      style={
                                        !showAll && index >= 3
                                          ? { filter: "blur(4px)" }
                                          : {}
                                      }
                                    >
                                      <td>{index + 1}</td>

                                      <td className="border p-2 relative">
                                        {item?.image ? (
                                          <div
                                            className="inline-block"
                                            onMouseEnter={() =>
                                              setHoveredImage(index)
                                            }
                                            onMouseLeave={() =>
                                              setHoveredImage(null)
                                            }
                                          >
                                            {/* Small image */}
                                            <LazyImageComponent
                                              src={item?.image}
                                              alt={item?.item}
                                              width="3000"
                                              height="100"
                                            />

                                            {/* Zoomed image */}
                                            {hoveredImage === index && (
                                              <div className=" position-absolute left-full ml-2 z-50">
                                                <img
                                                  src={item?.image}
                                                  alt={item?.item}
                                                  className="border rounded shadow-lg"
                                                  style={{
                                                    width: "200px",
                                                    height: "200px",
                                                    objectFit: "contain",
                                                    zIndex: 50,
                                                    background: "black",
                                                  }}
                                                />
                                              </div>
                                            )}
                                          </div>
                                        ) : (
                                          "NA"
                                        )}
                                      </td>
                                      <td>
                                        {item?.item}
                                        <br />
                                        {item?.hsn && <b>{item?.hsn}</b>}
                                      </td>
                                      <td>
                                        {(item?.specificationsNew ?? []).map(
                                          (type, i) =>
                                            type?.specification &&
                                            type?.type === "cea" ? (
                                              <span key={i} className="p-0 m-0">
                                                {type?.specification || "-"}{" "}
                                                {hydrponicType}
                                              </span>
                                            ) : null
                                        )}
                                      </td>
                                      <td style={{ width: "120px" }}>
                                        {item?.count || "N/A"} {"  "}
                                        {item?.unit || "N/A"}
                                      </td>
                                      <td>{roundOffCost(item?.cost)}</td>
                                      <td style={{ width: "220px" }}>
                                        Pre Gst Price:{" "}
                                        {roundOffCost(item?.count * item?.cost)}
                                        <br />
                                        <p className="color-lime text-green">
                                          Gst Amount:{" "}
                                          {roundOffCost(
                                            item?.count *
                                              item?.cost *
                                              (item?.gst / 100)
                                          )}{" "}
                                          ({item?.gst}%)
                                        </p>
                                      </td>
                                      <td>
                                        {(() => {
                                          const tPrice =
                                            item?.count * item?.cost;
                                          const gstRate = item?.gst
                                            ? item.gst
                                            : 18;
                                          const gstAmount =
                                            (tPrice * gstRate) / 100;
                                          const postGst = tPrice + gstAmount;
                                          return roundOffCost(postGst);
                                        })()}
                                      </td>
                                    </tr>
                                  ) : null
                                )}
                              <tr style={!showAll ? { display: "none" } : {}}>
                                <td colSpan="7" className="text-end fw-bold">
                                  Total Cost Including Fabrication and Handling
                                  Charges:
                                </td>
                                <td>{totalCost}</td>
                              </tr>
                            </tbody>
                          </table>

                          <table className="table table-vcenter border mt-4">
                            <thead>
                              <tr>
                                <th>Sr</th>
                                <th>Charges</th>
                                <th>Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {showAll && (
                                <React.Fragment>
                                  <tr>
                                    <td>1</td>
                                    <td className="text-start">
                                      Fabrication Charges on sale <br /> 998873
                                    </td>
                                    <td>₹{fabricationCharges || 0}</td>
                                  </tr>
                                  <tr>
                                    <td>2</td>
                                    <td className="text-start">
                                      Handling Charges on sale
                                    </td>
                                    <td>₹{handlingCharges || 0}</td>
                                  </tr>

                                  <tr>
                                    <td>3</td>
                                    <td className="text-start">
                                      Output CGST @9%
                                    </td>
                                    <td>₹{gst18Percent / 2}</td>
                                  </tr>

                                  <tr>
                                    <td>4</td>
                                    <td className="text-start">
                                      Output SGST @9%
                                    </td>
                                    <td>₹{gst18Percent / 2}</td>
                                  </tr>

                                  <tr>
                                    <td>5</td>
                                    <td className="text-start">
                                      Output CGST @2.5%
                                    </td>
                                    <td>₹{gst5Percent / 2}</td>
                                  </tr>

                                  <tr>
                                    <td>6</td>
                                    <td className="text-start">
                                      Output SGST @2.5%
                                    </td>
                                    <td>₹{gst5Percent / 2}</td>
                                  </tr>

                                  <tr>
                                    <td>7</td>
                                    <td className="text-start">
                                      Output CGST @6%
                                    </td>
                                    <td>₹{gst12Percent / 2}</td>
                                  </tr>

                                  <tr>
                                    <td>8</td>
                                    <td className="text-start">
                                      Output SGST @6%
                                    </td>
                                    <td>₹{gst12Percent / 2}</td>
                                  </tr>

                                  <tr>
                                    <td>9</td>
                                    <td className="text-start fw-bold">
                                      Total Charges
                                    </td>

                                    <td className="fw-bold">
                                      ₹
                                      {parseFloat(
                                        (gst18Percent || 0) +
                                          (gst12Percent || 0) +
                                          (gst5Percent || 0) +
                                          (fabricationCharges || 0)
                                      ).toFixed(2)}
                                    </td>
                                  </tr>
                                </React.Fragment>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {/* <div className="card-footer mt-3 d-print-none">
                      <div className="btn-list justify-content-end d-print-none">
                        <button
                          className="btn btn-primary"
                          data-bs-toggle="modal"
                          data-bs-target="#modal-report-1"
                          id="opensuccessmodal"
                          style={showAll ? { display: "none" } : {}}
                        >
                          Get Full Access
                        </button>
                        <button
                          className="btn mx-1 mt-2 btn-primary"
                          onClick={() => handleDownload(hydrponicType)}
                          style={!showAll ? { display: "none" } : {}}
                        >
                          <FaFilePdf className="me-2 fs-2" />
                          DOWNLOAD PDF
                        </button>
                      </div>
                    </div> */}
                  </div>
                  <div
                    ref={paymentRef}
                    className="border border-2  rounded  rounded-2 p-2 mt-5  text-start"
                  >
                    <table style={{ width: "100%" }}>
                      <tbody>
                        <tr>
                          <td style={{ width: "42%" }}>
                            <table style={{ width: "100%" }}>
                              <thead>
                                <tr>
                                  <th>Payment Schedule</th>
                                  <th>Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Work order & advance (50%)</td>
                                  <td>{roundOffCost(totalCost / 2)}</td>
                                </tr>
                                <tr>
                                  <td>
                                    Before 1<sup>st</sup> vehicle dispatch (50%)
                                  </td>
                                </tr>

                                <tr>
                                  <td>Total (100%)</td>
                                  <td>{roundOffCost(totalCost)}</td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td style={{ width: "42%" }}>
                            <p>
                              <b>Payment Details</b>
                              <br />
                              Name: <b>KRYZEN BIOTECH PRIVATE LIMITED</b>
                              <br />
                              Bank: <b>ICICI BANK</b>
                              <br />
                              Account No.: <b>016905015915</b>
                              <br />
                              IFSC: <b>ICIC0007565</b>
                              <br />
                              Book your site inspection by paying via UPI /
                              Debit Card / Credit Card / Net Banking / Wallets /
                              NBFC.
                              <br />
                            </p>
                          </td>
                          <td style={{ width: "16%" }}>
                            <p style={{ textAlign: "center" }}>
                              Payment + Payment Getway Fee
                              <img
                                width={"140px"}
                                src={
                                  "https://res.cloudinary.com/bsgfcooa/image/upload/v1753080572/QrCode_tem4c0_i3godi_axhqdz.jpg"
                                }
                                alt="kryzen QrCode"
                              />
                            </p>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        border: "none",
                        marginTop: "0.2em",
                      }}
                    >
                      <span style={{ width: "50%", border: "none" }}></span>
                      <span
                        style={{
                          textAlign: "right",
                          width: "40%",
                          border: "none",
                        }}
                      >
                        <img
                          width={"50%"}
                          src={
                            "https://res.cloudinary.com/bsgfcooa/image/upload/v1753079878/signature_cztq8j_p5hwwc_me2vci.png"
                          }
                          alt="kryzen signature"
                        />
                      </span>
                    </div>
                    <hr />

                    <div className="mt-4  rounded  rounded-2">
                      <p>
                        <b>Terms & conditions:</b>
                        <br />
                      </p>
                      <ol
                        style={{ marginBottom: "10px", fontSize: "14px" }}
                        className="text-start lh-4"
                      >
                        <li>
                          This quote is subject to the Sale Conditions listed
                          below. KBPL will not be bound by any revisions,
                          alterations, or additions to these terms, even if they
                          are included in your proposal acceptance, unless
                          specifically agreed in writing.
                        </li>

                        <li>
                          Once work-order is received and work has started, the
                          amount received is non-refundable.
                        </li>
                        <li>Advance will be considered as work order.</li>

                        <li>
                          KBPL is not responsible for missing, damaged, loss and
                          theft of materials after delivery.
                        </li>

                        <li>
                          Transportation of goods & labours ex factory to the
                          site location charges are extra. Any extra services
                          will be charged additionally.
                        </li>

                        <li>
                          On Subsidy approval, subsidy amount will be directly
                          credited into your bank account. KBPL has no control
                          over any process once your file is processed from our
                          end.
                        </li>
                        <li>
                          KBPL's offers are subject to terms and limitations.
                          KBPL retains the right to make adjustments to offers.
                        </li>
                        <li>
                          KBPL is not responsible for disapproval of subsidy or
                          loan on any grounds.
                        </li>
                        <li>
                          Any contention to Law will be subject to Pune
                          Jurisdiction only.
                        </li>

                        <li>
                          Above quote is valid for 20 days from the date of
                          generation.
                        </li>
                      </ol>
                    </div>
                    <div
                      className="html2pdf__page-break"
                      style={{
                        pageBreakAfter: "always",
                        display: "block",
                        clear: "both",
                      }}
                    ></div>
                  </div>
                  <div className="card-footer mt-3 d-print-none">
                    <div className="btn-list justify-content-end d-print-none">
                      <button
                        className="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#modal-report-1"
                        id="opensuccessmodal"
                        style={showAll ? { display: "none" } : {}}
                      >
                        Get Full Access
                      </button>
                      <button
                        className="btn mx-1 mt-2 btn-primary"
                        onClick={() => handleDownload(hydrponicType)}
                        style={!showAll ? { display: "none" } : {}}
                      >
                        <FaFilePdf className="me-2 fs-2" />
                        DOWNLOAD PDF
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>

      {/* modal */}

      <div
        className="modal modal-blur fade"
        id="modal-report-1"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Enter Your Detail For Full Access</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="btn-close"
              ></button>
            </div>
            <div className="modal-body">
              {true && (
                <>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Full name</label>
                    <div className="w-100 col">
                      <input
                        type="text"
                        className="form-control"
                        value={name || ""}
                        onChange={(e) => [setName(e.target.value)]}
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Email Address
                    </label>
                    <div className="w-100 col">
                      <input
                        type="email"
                        className="form-control"
                        value={email || ""}
                        onChange={(e) => [setEmail(e.target.value)]}
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Phone Number
                    </label>
                    <div className="w-100 col">
                      <input
                        type="text"
                        className="form-control"
                        value={mobile || ""}
                        maxLength={13}
                        required
                        onChange={(e) => [setMobile(e.target.value)]}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="modal-footer">
              <div className="ms-auto">
                <button
                  className="btn btn-primary"
                  onClick={() => handleUserData()}
                  data-bs-dismiss="modal"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal modal-blur fade"
        id="modal-report-2"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-full-width" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title"> Layout Design</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="layout-btn-close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="">
                <PolyhouseDesigner
                  length={length}
                  width={width}
                  BASE_SCALE={24}
                  showBC={true}
                  showHC={true}
                  showGrid={true}
                  showLabels={true}
                  showOutline={true}
                  entryStartLabel={""}
                  footingDiaM={footingDiaM}
                  blockName={blockName}
                />
              </div>
            </div>

            <div className="modal-footer">
              <div className="ms-auto">
                <button className="btn btn-secondary" data-bs-dismiss="modal">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderCeaKitTable;
